import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrVitalService {
  temrVital: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'temr_vital/list/?';
  private ListRecordbyTimelineId = webapi + 'temr_vital/listbytimelineid/?';
  private AddRecord = webapi + 'temr_vital/create';
  private EditRecord = webapi + 'temr_vital/update';
  private GetRecord = webapi + 'temr_vital/byid/';
  private GetRecordByVisitId = webapi + 'temr_vital/byvisitid/';
  private DeleteRecord = webapi + 'temr_vital/delete/';
  private GetVitaldetailsByPatientId = webapi + 'temr_vital/getVitaldetailsByPatientId/';
  private GetAllRecordByTimelineList = webapi + 'temr_vital/getAllRecordByTimelineList';
  private GetRecordServicebyTimelineId = webapi + 'temr_vital/getrecordbytimelineid/?';
  private GetRecordServicebyVisitId = webapi + 'temr_vital/getrecordbyVisitId/?';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    // console.log(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col);
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServicebyTimelineId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecordbyTimelineId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  getRecordServiceByVisitId(id: any) {
    return this.http.get(this.GetRecordByVisitId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getVitaldetailsByPatientId(patientId: any, startdate: any, enddate: any, page: any, size: any) {
    return this.http.get(this.GetVitaldetailsByPatientId + patientId + '/' + startdate + '/' + enddate + '/' + page + '/' + size)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByTimelineList(model: any) {
    return this.http.post(this.GetAllRecordByTimelineList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordServicebyTimelineId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.GetRecordServicebyTimelineId + 'qString=' + qString)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  getRecordServicebyVisitId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.GetRecordServicebyVisitId + 'qString=' + qString)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-vital/temr-vital.service.ts